import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'
import MAX_INPUT_COUNT from './constants'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.genders === undefined || widgetSetting.genders === null

const isOverMaxInput = (insights: InsightData[]) => insights.length > MAX_INPUT_COUNT

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: (InsightData & { levelOneFilter?: string })[]
) => ({
  ...widgetSetting,
  genders: insights.map((insight) => insight.levelOneFilter || insight.name)
})

const generateGendersStrategy = (): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput,
  composeDrillDownWidgetSetting
})

export default generateGendersStrategy
